import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores'
import routes from './routes'

const router = createRouter({
  history: createWebHistory('/dashboard'),
  routes,
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  if (!authStore.initialized) {
    await authStore.initialize()
  }

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const requiredRole = to.matched.find((record) => record.meta.role)?.meta.role as
    | string
    | undefined

  if (requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  if (requiredRole === 'admin' && !authStore.isAdmin) {
    return next({ name: 'marketplace' })
  }

  if (requiredRole === 'developer' && !authStore.isDeveloper) {
    return next({ name: 'marketplace' })
  }


  if (authStore.isAuthenticated && to.matched.some((record) => record.meta.guestOnly)) {
    return next({ name: 'developer-dashboard' })
  }

  next()
})

export default router
